/* eslint-disable react/jsx-no-target-blank */
import React, { FunctionComponent } from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faInstagram, faFacebook, faDiscord, faTiktok } from '@fortawesome/free-brands-svg-icons';
import { faHeart } from '@fortawesome/free-solid-svg-icons';

// import { External } from '../icons';
import { Section } from '../Section';

import style from './Footer.module.less';

export const Footer: FunctionComponent = () => (
  <footer>
    <Section alternate={true} straightBottom={true} className={style.footerSection}>
      <div className={style.footerContainer}>
        <div className={classnames(style.footerSection, style.footerSectionCompany)}>
          <h4>Eleven Puzzles</h4>
          <p className={style.madeWithLove}>Made with <FontAwesomeIcon className={style.heart} icon={faHeart} /> <br />in Poland</p>
        </div>

        <div className={style.footerSection}>
          <h4>Games</h4>
          <ul>
            <li><Link to="/unsolved-case">Unsolved Case (free)</Link></li>
            <li><Link to="/unboxing-the-cryptic-killer">Unboxing the Cryptic Killer</Link></li>
            <li><Link to="/parallel-experiment">Parallel Experiment</Link></li>
          </ul>
        </div>

        <div className={style.footerSection}>
          <h4>Web Games</h4>
          <ul>
            <li><Link to="/web-games/unboxing-the-mind-of-a-cryptic-killer">Unboxing the mind of a Cryptic Killer</Link></li>
            <li><Link to="/web-games/parallel-lab">Parallel Lab</Link></li>
            <li><Link to="/message">Love Box (free)</Link></li>
          </ul>
        </div>

        <div className={style.footerSection}>
          <h4>Info & more</h4>
          <ul>
            <li><Link to="/press-kit">Press kit</Link></li>
            <li><Link to="/privacy-policy">Privacy policy</Link></li>
            <li><Link to="/careers">Careers</Link></li>
            <li><Link to="/about-us">About us</Link></li>
          </ul>
        </div>

        <div className={style.footerSection}>
          <h4>Follow us</h4>
          <div className={style.socialLinks}>
            <a href="https://discord.gg/QwazPb3QeY" target="_blank"><FontAwesomeIcon className={style.icon} icon={faDiscord} /></a>
            <a href="https://www.facebook.com/elevenpuzzles" target="_blank"><FontAwesomeIcon className={style.icon} icon={faFacebook} /></a>
            <a href="https://www.instagram.com/elevenpuzzles/" target="_blank"><FontAwesomeIcon className={style.icon} icon={faInstagram} /></a>
            <a href="https://twitter.com/elevenpuzzles" target="_blank"><FontAwesomeIcon className={style.icon} icon={faTwitter} /></a>
            <a href="https://www.tiktok.com/@eleven_puzzles" target="_blank"><FontAwesomeIcon className={style.icon} icon={faTiktok} /></a>
          </div>
        </div>
      </div>
    </Section>
  </footer>
);
